import { AssetCategoryEntity, AssetEntity } from 'src/modules/assets';

export enum ProfessionalsDownloadsDocumentsActions {
  FetchAssetsBegin = 'PROFESSIONALS/DOWNLOADS/DOCUMENTS/FETCH_ASSETS/BEGIN',
  FetchAssetsSuccess = 'PROFESSIONALS/DOWNLOADS/DOCUMENTS/FETCH_ASSETS/SUCCESS',
  FetchAssetsError = 'PROFESSIONALS/DOWNLOADS/DOCUMENTS/FETCH_ASSETS/ERROR',
}

export interface ProfessionalsDownloadsDocumentsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  results: AssetEntity[];
  assetCategories: AssetCategoryEntity[];
}
